var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordcounter-group"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"wordcounter",class:{ 'counter-alert': _vm.count > _vm.maxCount }},[_vm._v(_vm._s(_vm.count)+" / "+_vm._s(_vm.maxCount))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }